import { render, staticRenderFns } from "./ThemeChangeButton.vue?vue&type=template&id=a46e43b2&scoped=true"
import script from "./ThemeChangeButton.vue?vue&type=script&lang=js"
export * from "./ThemeChangeButton.vue?vue&type=script&lang=js"
import style0 from "./ThemeChangeButton.vue?vue&type=style&index=0&id=a46e43b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46e43b2",
  null
  
)

export default component.exports